import React,{Component} from 'react';
import {Breadcrumb, Row, Col} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import {FaInfoCircle, FaShare,FaEnvelope, FaHome} from 'react-icons/fa';
import {HeaderButton, HeaderDiv, LiboldNavyBlue} from '../../theme/MorsTheme';
  
  export default class HeaderTitle extends Component{

    render(){
      return(        
        <div>
          <Row noGutters align="right">
              <Col as={Col} className="d-none d-md-block">                    
                  <a href={'http://www.bdo.com.ph/personal'}>
                      <HeaderButton>
                          <span><font style={{color:'white',margin:'5px'}}> <span style={{fontSize:'12px'}}><FaHome/></span> GO BACK TO BDO.COM.PH</font></span>                                                                                                                
                      </HeaderButton>
                  </a>                                                                
              </Col>
          </Row>
          <Row noGutters align="right" style={{padding:'5px 20px 0px 0px'}}>
              <Col as={Col} className="d-none d-md-block">
              <a href="http://www.bdo.com.ph/personal" style={{padding:'10px'}}>
                  <span style={{color:'black',fontSize:'12px'}}><FaHome/></span>                        
              </a>
              
              <a href="http://www.bdo.com.ph/personal" style={{padding:'10px'}}>
                  <span style={{color:'black',fontSize:'12px'}}><FaEnvelope/></span>                        
              </a>
              <a href="http://www.bdo.com.ph/personal" style={{padding:'10px'}}>
                  <span style={{color:'black',fontSize:'12px'}}>
                  <FaInfoCircle/>
                  </span>                        
              </a>
              <a href="http://www.bdo.com.ph/personal" style={{padding:'10px'}}>
                  <span style={{color:'black', fontSize:'12px'}}><FaShare/></span>                        
              </a>                
              </Col>
          </Row>                
          <Row noGutters className="d-none d-md-block">                                            
              <HeaderDiv style={{paddingTop:'7px', height:'83px'}} >                                                
                  <hr style={{height:'1px',border:'none',backgroundColor:'#FFB20C'}}/>                         
                  <span style={{color:'white', fontSize:'30px', fontWeight:'bold'}}>
                  Merchant Online Reporting System
                  </span>                                            
              </HeaderDiv>                  
          </Row>                 
          <Row noGutters className="d-md-block" style={{padding:'15px 0px 0px 0px'}}>

          {(this.props.hideBreadCrumb) ? 
            <Breadcrumb bsPrefix='breadcrumb'>                      
            <Breadcrumb.Item active><LiboldNavyBlue>Expired Password</LiboldNavyBlue></Breadcrumb.Item>                
          </Breadcrumb>           
            :   
          <Breadcrumb bsPrefix='breadcrumb'>          
          <Breadcrumb.Item><Link to="/main"><LiboldNavyBlue>Home</LiboldNavyBlue></Link></Breadcrumb.Item>
          <Breadcrumb.Item active><LiboldNavyBlue>{this.props.breadcrumbs}</LiboldNavyBlue></Breadcrumb.Item>                
        </Breadcrumb>             
          }
            </Row>
          </div>
    

      )
    }
  }




